import Delay from '../utils/Delay';
import axios from 'axios';
import {AxiosCall} from '../axios';
import {environment} from '../environment/environment';

const successRes = {
  status: true
};
const failureRes = {
  message: 'USER_LOGIN_FAILURE',
  status: false
};
const loginUrl = environment.apiEndPoints.auth.login;
const azureSSOLogin = environment.apiEndPoints.auth.azureSSOLogin;
const resetPwdUrl = '/auth/reset-password';
const verifyUser = '/auth/verify-user';
const verifyResetTokenUrl = resetPwdUrl + '/verify-token';
const createPassword = '/auth/create-password';
const forgotPasswordUrl = environment.apiEndPoints.public.forgotPassword;
const resendVerificationLinkUrl = '/auth/resend-verification-link';
const acceptInvitationUrl = '/auth/group/accept-invitation';
const verifyOTPUrl = '/auth/verify-otp';
const resendOTPUrl = '/auth/resend-otp';
// const userUrl = '/v1/user/me';

// How long to wait for fake async action to complete
const delayMs = 1000;

export const setAuthorizationHeader = (token: string): void => {
  if (token) {
    axios.defaults.headers.common['authorization'] = `Bearer ${token}`;
  }
};

export const loginService = async (values: any): Promise<any> => {
  try {
    const response = await AxiosCall.post(loginUrl, values);
    if (response?.token) {
      setAuthorizationHeader(response.token);
    }
    return response;
  } catch (err) {
    if (err.data) {
      throw err.data;
    }
    throw err;
  }
};

export const loginAzureSSOService = async (
  accessToken: any,
  refreshToken: any,
  idToken: any
): Promise<any> => {
  try {
    const values = {
      access_token: accessToken,
      refresh_token: refreshToken,
      id_token: idToken
    };
    const response = await axios.post(azureSSOLogin, values);
    return response.data;
  } catch (error) {
    return {error, azureSSOLogin};
  }
};

export const logoutService = async (values: any): Promise<any> => {
  await Delay(delayMs);
  return successRes;
};

export const registerService = async (values: any): Promise<any> => {
  await Delay(delayMs);
  return failureRes;
};

export const forgotPasswordService = async (values: {
  email: string;
}): Promise<any> => {
  return AxiosCall.post(forgotPasswordUrl, values);
};

export const resetPasswordService = async (values: any): Promise<any> => {
  try {
    return await AxiosCall.post(resetPwdUrl, values);
  } catch (error) {
    if (error && error.response && error.response.data) {
      throw error.response.data;
    } else {
      throw error;
    }
  }
};

export const verifyUserService = async (values: any): Promise<any> => {
  try {
    return await AxiosCall.post(verifyUser, values);
  } catch (error) {
    if (error && error.response && error.response.data) {
      throw error.response.data;
    } else {
      throw error;
    }
  }
};

export const createPasswordService = async (values: any): Promise<any> => {
  try {
    return await AxiosCall.post(createPassword, values);
  } catch (error) {
    if (error && error.response && error.response.data) {
      throw error.response.data;
    } else {
      throw error;
    }
  }
};

export const verifyResetToken = async (values: any): Promise<any> => {
  try {
    return await AxiosCall.post(verifyResetTokenUrl, values);
  } catch (error) {
    if (error && error.response && error.response.data) {
      throw error.response.data;
    } else {
      throw error;
    }
  }
};

export const resendVerificationLink = async (data: {
  email: string;
}): Promise<any> => {
  try {
    return await AxiosCall.post(resendVerificationLinkUrl, data);
  } catch (error) {
    if (error && error.response && error.response.data) {
      throw error.response.data;
    } else {
      throw error;
    }
  }
};

export const acceptInvitationService = async (data: {
  token: string;
}): Promise<any> => {
  try {
    return await AxiosCall.post(acceptInvitationUrl, data);
  } catch (error) {
    if (error && error.response && error.response.data) {
      throw error.response.data;
    } else {
      throw error;
    }
  }
};

export const verifyOTP = async (payload: {otp: string}): Promise<any> => {
  return await AxiosCall.post(verifyOTPUrl, payload);
};

export const resendOTP = async (): Promise<any> => {
  return await AxiosCall.post(resendOTPUrl, {});
};
